// Static list, Cameroon first given the platform's primary market (+237
// default phone prefix elsewhere in this form). Extend as needed.
export const COUNTRIES: string[] = [
  "Cameroun",
  "Bénin",
  "Burkina Faso",
  "Côte d'Ivoire",
  "France",
  "Gabon",
  "Ghana",
  "Guinée",
  "Mali",
  "Maroc",
  "Niger",
  "Nigeria",
  "République Démocratique du Congo",
  "République du Congo",
  "Sénégal",
  "Tchad",
  "Togo",
  "Tunisie",
  "Autre",
];
